import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const HeaderContainer = styled.header`
  position: absolute;
  border-top: ${({ theme }) => `6px solid ${theme.primaryColor}`};
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: top;
  > .icon {
    ${fontSize(22)};
    height: 25px;
    cursor: pointer;
    color: ${({ theme }) => theme.primaryColor};
  }
  > .logo {
    cursor: default;
  }
  ${media.desktop`
    padding: 15px 20px;
  `};
`;

export const TitleHeader = styled.h1`
  display: none;
  color: ${({ theme }) => theme.primaryColor};
  ${fontSize(16)};
  font-weight: 500;
  letter-spacing: 0.5px;
  margin: auto;
  ${media.desktop`
    display: block;
    margin: auto 15px;
    flex: 1;
  `};
`;
